var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('--viewHeight: ' +
      _vm.$store.state.viewPort.height +
      'px; --scrollY: ' +
      _vm.scrollbarY),attrs:{"id":"app"}},[(!_vm.disabledHeaderAndFooter)?_c('head-nav',{attrs:{"white":_vm.whiteMenu}}):_vm._e(),_c('router-view',{class:['content', _vm.whiteMenu && 'marginTop']}),(!_vm.disabledHeaderAndFooter)?_c('footer-nav',{staticClass:"footer"}):_vm._e(),_c('CookiesNotice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }